import { bookingAPI, eventBookingAPI } from './api';

/**
 * Get all booked dates for a specific room
 * @param {string} roomType - The room type (e.g., "Single Room", "Double Room", "Deluxe Room")
 * @returns {Promise<Date[]>} Array of booked dates
 */
export const getBookedDatesForRoom = async (roomType) => {
  try {
    if (!roomType) return [];
    
    // Fetch booked dates from the API endpoint with room_type filter
    const response = await bookingAPI.getBookedDates({ room_type: roomType });
    const bookedDateStrings = response.data.data || [];
    
    // Convert strings to Date objects
    const bookedDates = bookedDateStrings.map(dateStr => new Date(dateStr));
    
    return bookedDates;
  } catch (error) {
    console.error('Error fetching booked dates:', error);
    return [];
  }
};

/**
 * Get all booked dates for event bookings
 * @returns {Promise<Date[]>} Array of booked event dates
 */
export const getBookedEventDates = async () => {
  try {
    // Fetch booked dates from the public endpoint
    const response = await eventBookingAPI.getBookedDates();
    const bookedDateStrings = response.data.data || [];
    
    // Convert strings to Date objects
    const bookedDates = bookedDateStrings.map(dateStr => new Date(dateStr));
    
    return bookedDates;
  } catch (error) {
    console.error('Error fetching booked event dates:', error);
    return [];
  }
};

/**
 * Check if a date is booked
 * @param {Date} dateToCheck - The date to check
 * @param {Date[]} bookedDates - Array of booked dates
 * @returns {boolean} True if the date is booked
 */
export const isDateBooked = (dateToCheck, bookedDates) => {
  if (!dateToCheck || !bookedDates.length) return false;
  
  return bookedDates.some(bookedDate => {
    return (
      dateToCheck.getFullYear() === bookedDate.getFullYear() &&
      dateToCheck.getMonth() === bookedDate.getMonth() &&
      dateToCheck.getDate() === bookedDate.getDate()
    );
  });
};
